// utils/createMaterial.js

import * as THREE from 'three';

// Basic material creator function
export const createMaterialLaserCut = (color, opacity = 1, transparent = false) => {
  return new THREE.MeshStandardMaterial({
    color,
    opacity,
    transparent,
    depthWrite: true,
    polygonOffset: true,
    polygonOffsetFactor: 0.1,
    polygonOffsetUnits: 0.1,
    premultipliedAlpha: true,
  });
};

// Function to create common materials for reuse
export const createCachedMaterialsLaserCutInterlocking = () => ({
  woodMaterial: new THREE.MeshStandardMaterial({
    color: 0xd4b795,
    roughness: 0.7,
    metalness: 0.05,
    envMapIntensity: 0.4,
    side: THREE.DoubleSide,
  }),
  hplaneMaterial: createMaterialLaserCut(0xd4b795),
  vplaneMaterial: createMaterialLaserCut(0xd4b795),
  greenBoxMaterial: new THREE.MeshBasicMaterial({ color: 0xdeb887 }),
  blueBoxMaterial: new THREE.MeshBasicMaterial({ color: 0xdeb887 }),
  originalModelMaterial: new THREE.MeshNormalMaterial({
    transparent: true,
    opacity: 0.5,
  })
});

export const createCachedMaterialsStackedLaserCut = () => ({
  woodMaterial: new THREE.MeshStandardMaterial({
    color: 0xd4b795,
    roughness: 0.7,
    metalness: 0.05,
    envMapIntensity: 0.4,
    side: THREE.DoubleSide,
  }),
  layerMaterial: createMaterialLaserCut(0xF5DEB3),
  outlineMaterial: new THREE.LineBasicMaterial({ color: 0x000000 }),
  rodMaterial: new THREE.MeshStandardMaterial({
    color: 0x808080,
    metalness: 0.8,
    roughness: 0.2,
    side: THREE.DoubleSide,
  }),
  originalModelMaterial: new THREE.MeshNormalMaterial({
    transparent: true,
    opacity: 0.5,
  })
});